import { Injectable } from "@angular/core";
import { IPredisposition, IPredispositionsFilters, IRisksFilters } from "@gloria-public/home/domain/interfaces/home.interface";
import { IRiskTemplateResponse } from "@gloria-public/risk/domain/interfaces/risk.interface";
import { ApiService } from "@shared/services/api.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class HomeService {
  constructor(private api: ApiService) {}

  /**
   * Returns a paginated list of risks not yet ordered by the connected user
   * @param filters Filters to use to sort out the list
   * @returns A paginated list of risks not ordered
   */
  public getNotOrderedRisks(filters: IRisksFilters): Observable<IRiskTemplateResponse[]> {
    const params: Record<string, string | number> = {
      page: filters.page ?? 1,
      pageSize: filters.pageSize ?? 10,
    };
    if (filters.lang) params["lang"] = filters.lang;
    if (filters.sortByDate) params["sortByDate"] = filters.sortByDate;

    return this.api.get("home/risks/not-ordered", params) as Observable<IRiskTemplateResponse[]>;
  }

  /**
   * Returns the total count of risks not yet ordered by the connected user
   * @returns The total count of risks not ordered
   */
  public getNotOrderedRisksCount(): Observable<number> {
    return this.api.get("home/risks/not-ordered/count") as Observable<number>;
  }

  /**
   * Returns a paginated list of predispositions that the user has already started
   * @param filters Filters to use to sort out the list
   * @returns A paginated list of predispositions
   */
  public getPredispositions(filters: IPredispositionsFilters): Observable<IPredisposition[]> {
    const params: Record<string, string | number> = {
      lang: filters.lang,
      page: filters.page ?? 1,
      pageSize: filters.pageSize ?? 10,
    };

    if (filters.sortByDate) params["sortByDate"] = filters.sortByDate;
    if (filters.tags?.length) params["tags"] = filters.tags.join(",");

    return this.api.get("home/predispositions", params) as Observable<IPredisposition[]>;
  }

  /**
   * Returns the total count of predispositions that the user has already started
   * @returns The total count of predispositions
   */
  public getPredispositionsCount(tags?: string[]): Observable<number> {
    const params: Record<string, string> = {};

    if (tags?.length) params["tags"] = tags.join(",");

    return this.api.get("home/predispositions/count", params) as Observable<number>;
  }
}
